import { defineMessages } from 'react-intl';

export const scope = 'extraction_documents';

export default defineMessages({
    pdf_view_error: {
        id: `${scope}.pdf_view_error`,
        defaultMessage: 'PDF viewer failed to load.',
    },
    invalid_file: {
        id: `${scope}.invalid_file`,
        defaultMessage: 'Invalid file.',
    },
    pdf_render_error: {
        id: `${scope}.pdf_render_error`,
        defaultMessage: 'Failed to render PDF page.',
    },
    no_file_data: {
        id: `${scope}.no_file_data`,
        defaultMessage: 'No file data available.',
    },
    approve_data_error: {
        id: `${scope}.approve_data_error`,
        defaultMessage: 'Failed to approve. No file data available.',
    },
    approve_error: {
        id: `${scope}.approve_error`,
        defaultMessage: 'Failed to approve the document.',
    },
    approve_success: {
        id: `${scope}.approve_success`,
        defaultMessage: 'Document approved successfully.',
    },
    download_error: {
        id: `${scope}.download_error`,
        defaultMessage: 'Download failed. Please try again.',
    },
    document_selection_check: {
        id: `${scope}.document_selection_check`,
        defaultMessage: 'Please select a document type and try again.',
    },
    file_selection_error: {
        id: `${scope}.file_selection_error`,
        defaultMessage: 'Please select a file and try again.',
    },
    invalid_file_url: {
        id: `${scope}.invalid_file_url`,
        defaultMessage: 'Invalid file URL.',
    }
});
